var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 21,
    viewBox: "0 0 50 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.863 3.13928H20.1113V18.8625H28.863V3.13928Z",
    fill: "#FF5A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6937 10.9996C20.6937 7.80515 22.1955 4.96992 24.4999 3.13802C22.804 1.80456 20.6646 0.998657 18.3311 0.998657C12.803 0.998657 8.33008 5.47159 8.33008 10.9996C8.33008 16.5277 12.803 21.0006 18.3311 21.0006C20.6646 21.0006 22.804 20.1947 24.4999 18.8612C22.1923 17.0552 20.6937 14.1941 20.6937 10.9996Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6699 10.9996C40.6699 16.5277 36.1969 21.0006 30.6689 21.0006C28.3353 21.0006 26.196 20.1947 24.5 18.8612C26.8336 17.0261 28.3062 14.1941 28.3062 10.9996C28.3062 7.80515 26.8044 4.96992 24.5 3.13802C26.1927 1.80456 28.3321 0.998657 30.6656 0.998657C36.1969 0.998657 40.6699 5.50072 40.6699 10.9996Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMastercard);
export default __webpack_public_path__ + "static/media/logo-mastercard.83d1c5927d1e3af5e865b8f094f7429b.svg";
export { ForwardRef as ReactComponent };